module.exports = __webpack_public_path__ + "images/img-2nitaRo.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/month.jpg
// module id = 1999
// module chunks = 0